import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/e-mail-disclaimer")({
  head: () => buildRouteHead("/en/e-mail-disclaimer", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/privacy-policy", replace: true });
  },
});
